exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-content[data-v-b0385204] {\n  min-height: calc(100vh - 20px);\n  display: flex;\n  flex-direction: column;\n}\n.empty-state[data-v-b0385204] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-grow: 1;\n  width: 100%;\n}\n.empty-state .box[data-v-b0385204] {\n  width: 100%;\n  max-width: 400px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.empty-state .box p[data-v-b0385204],\n.empty-state .box h2[data-v-b0385204] {\n  margin-bottom: 0;\n}", ""]);

// exports
